// extracted by mini-css-extract-plugin
export var cardIcon = "_6r-5";
export var cardIconUnframed = "_6r-9";
export var checkboxCard = "_6r-0";
export var checkboxCardSelected = "_6r-4";
export var disabled = "_6r-2";
export var interactive = "_6r-1";
export var outerBorder = "_6r-3";
export var spacerMedium = "_6r-8";
export var spacerSmall = "_6r-7";
export var spacerXsmall = "_6r-6";